export const LOAD_DONATION_INFOR = 'app/containers/PremiumPage/LOAD_DONATION_INFOR';
export const LOAD_DONATION_INFOR_SUCCESS = 'app/containers/PremiumPage/LOAD_DONATION_INFOR_SUCCESS';
export const LOAD_DONATION_INFOR_ERROR = 'app/containers/PremiumPage/LOAD_DONATION_INFOR_ERROR';
